/** @jsxImportSource @emotion/react */

import type { CSSProperties, PropsWithChildren } from "react";

type LocalColorSchemeAreaProps = PropsWithChildren & {
  sx?: CSSProperties;
  theme: "light" | "dark" | "🌝" | "🌚";
};

const themeToString = (theme: LocalColorSchemeAreaProps["theme"]) =>
  theme === "🌝" || theme === "light" ? "light" : "dark";

/**
 * html의 theme을 무시하고, 해당 컴포넌트를 기준으로 theme을 설정할 수 있습니다.
 *
 * children 요소는 section tag 로 감싸지며 sx를 통해 section tag의 style을 직접 조정할 수 있습니다.
 */
export const LocalColorSchemeArea = (props: LocalColorSchemeAreaProps) => {
  return (
    <section className={`clay-${themeToString(props.theme)}-theme-area`} css={{ ...props.sx }}>
      {props.children}
    </section>
  );
};
